module.exports = __webpack_public_path__ + "img/symbol_5.e7963dbe.png";